import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.js';
import fr from './locales/fr.js';

const messages = {
  en,
  fr 
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages,
  fallbackLocale: 'en', // set fallback locale
  silentTranslationWarn: true
});

export default i18n;